import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setPayementInformation } from "../../../../store/actions";

const BillingAdressFields = ({ validationType, billAddress, edited, countryList, statesList, from }) => {
    return (
        <div>
            <div className='row mt-3'>
                <div className='form-filed col-12 col-md-6'>
                    <span className={(billAddress && (!edited || edited && from !== "popup")) ? `input-title-view` : `input-title`}>Billing name <span className="text-danger"> *</span></span>
                    {billAddress ? edited && from === "popup" ? (<div >
                        <input
                            name="bill_name"
                            type="text"
                            className={`input-value-filed ${validationType.touched.bill_name &&
                                validationType.errors.bill_name && `error-border`}`}
                            onChange={(e) => {
                                e.target.value = e.target.value;
                                validationType.handleChange(e);
                            }}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.bill_name?.trimStart() || ""}
                            invalid={
                                validationType.touched.bill_name &&
                                    validationType.errors.bill_name
                                    ? true
                                    : false
                            }
                        />
                        {validationType.touched.bill_name &&
                            validationType.errors.bill_name ? (
                            <div className='error-msg'>
                                {validationType.errors.bill_name}
                            </div>
                        ) : null}
                    </div>) : <div className='input-value-filed-value'>{billAddress.bill_name}</div> : <div >
                        <input
                            name="bill_name"
                            type="text"
                            className={`input-value-filed ${validationType.touched.bill_name &&
                                validationType.errors.bill_name && `error-border`}`}
                            onChange={(e) => {
                                e.target.value = e.target.value;
                                validationType.handleChange(e);
                            }}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.bill_name?.trimStart() || ""}
                            invalid={
                                validationType.touched.bill_name &&
                                    validationType.errors.bill_name
                                    ? true
                                    : false
                            }
                        />
                        {validationType.touched.bill_name &&
                            validationType.errors.bill_name ? (
                            <div className='error-msg'>
                                {validationType.errors.bill_name}
                            </div>
                        ) : null}
                    </div>}
                </div>
                <div className='form-filed col-12 col-md-6 mt-3 mt-md-0'>
                    <span className={(billAddress && (!edited || edited && from !== "popup")) ? `input-title-view` : `input-title`}>Billing email <span className="text-danger"> *</span></span>
                    {billAddress ? edited && from === "popup" ?
                        (<div >
                            <input
                                name="bill_email"
                                type="email"
                                className={`input-value-filed ${validationType.touched.bill_email &&
                                    validationType.errors.bill_email && `error-border`}`}
                                onChange={(e) => {
                                    e.target.value = e.target.value;
                                    validationType.handleChange(e);
                                }}
                                onBlur={validationType.handleBlur}
                                value={validationType.values.bill_email?.trimStart() || ""}
                                invalid={
                                    validationType.touched.bill_email &&
                                        validationType.errors.bill_email
                                        ? true
                                        : false
                                }
                            />
                            {validationType.touched.bill_email &&
                                validationType.errors.bill_email ? (
                                <div className='error-msg'>
                                    {validationType.errors.bill_email}
                                </div>
                            ) : null}
                        </div>) : <div className='input-value-filed-value'>{billAddress.bill_email}</div> :
                        <div >
                            <input
                                name="bill_email"
                                type="email"
                                className={`input-value-filed ${validationType.touched.bill_email &&
                                    validationType.errors.bill_email && `error-border`}`}
                                onChange={(e) => {
                                    e.target.value = e.target.value;
                                    validationType.handleChange(e);
                                }}
                                onBlur={validationType.handleBlur}
                                value={validationType.values.bill_email?.trimStart() || ""}
                                invalid={
                                    validationType.touched.bill_email &&
                                        validationType.errors.bill_email
                                        ? true
                                        : false
                                }
                            />
                            {validationType.touched.bill_email &&
                                validationType.errors.bill_email ? (
                                <div className='error-msg'>
                                    {validationType.errors.bill_email}
                                </div>
                            ) : null}
                        </div>}
                </div>
            </div>
            <div className='row mt-3'>
                <div className='form-filed col-12 col-md-6'>
                    <span className={(billAddress && (!edited || edited && from !== "popup")) ? `input-title-view` : `input-title`}>Address line 1 <span className="text-danger"> *</span></span>
                    {billAddress ? edited && from === "popup" ? (<div >
                        <input
                            name="add_l1"
                            type="text"
                            className={`input-value-filed ${validationType.touched.add_l1 &&
                                validationType.errors.add_l1 && `error-border`}`}
                            onChange={(e) => {
                                e.target.value = e.target.value;
                                validationType.handleChange(e);
                            }}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.add_l1?.trimStart() || ""}
                            invalid={
                                validationType.touched.add_l1 &&
                                    validationType.errors.add_l1
                                    ? true
                                    : false
                            }
                        />
                        {validationType.touched.add_l1 &&
                            validationType.errors.add_l1 ? (
                            <div className='error-msg'>
                                {validationType.errors.add_l1}
                            </div>
                        ) : null}
                    </div>) : <div className='input-value-filed-value'>{billAddress.add_l1}</div> : <div >
                        <input
                            name="add_l1"
                            type="text"
                            className={`input-value-filed ${validationType.touched.add_l1 &&
                                validationType.errors.add_l1 && `error-border`}`}
                            onChange={(e) => {
                                e.target.value = e.target.value;
                                validationType.handleChange(e);
                            }}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.add_l1?.trimStart() || ""}
                            invalid={
                                validationType.touched.add_l1 &&
                                    validationType.errors.add_l1
                                    ? true
                                    : false
                            }
                        />
                        {validationType.touched.add_l1 &&
                            validationType.errors.add_l1 ? (
                            <div className='error-msg'>
                                {validationType.errors.add_l1}
                            </div>
                        ) : null}
                    </div>}
                </div>
                <div className='form-filed col-12 col-md-6 mt-3 mt-md-0'>
                    <span className={(billAddress && (!edited || edited && from !== "popup")) ? `input-title-view` : `input-title`}>Address line 2</span>
                    {billAddress ? edited && from === "popup" ? (<div >
                        <input
                            name="add_l2"
                            type="text"
                            className={`input-value-filed ${validationType.touched.add_l2 &&
                                validationType.errors.add_l2 && `error-border`}`}
                            onChange={(e) => {
                                e.target.value = e.target.value;
                                validationType.handleChange(e);
                            }}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.add_l2?.trimStart() || ""}
                            invalid={
                                validationType.touched.add_l2 &&
                                    validationType.errors.add_l2
                                    ? true
                                    : false
                            }
                        />
                        {validationType.touched.add_l2 &&
                            validationType.errors.add_l2 ? (
                            <div className='error-msg'>
                                {validationType.errors.add_l2}
                            </div>
                        ) : null}
                    </div>) : <div className='input-value-filed-value'>{billAddress.add_l2 ? billAddress.add_l2 : "-"}</div> : <div >
                        <input
                            name="add_l2"
                            type="text"
                            className={`input-value-filed ${validationType.touched.add_l2 &&
                                validationType.errors.add_l2 && `error-border`}`}
                            onChange={(e) => {
                                e.target.value = e.target.value;
                                validationType.handleChange(e);
                            }}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.add_l2?.trimStart() || ""}
                            invalid={
                                validationType.touched.add_l2 &&
                                    validationType.errors.add_l2
                                    ? true
                                    : false
                            }
                        />
                        {validationType.touched.add_l2 &&
                            validationType.errors.add_l2 ? (
                            <div className='error-msg'>
                                {validationType.errors.add_l2}
                            </div>
                        ) : null}
                    </div>}
                </div>
            </div>
            <div className='row mt-3'>
                <div className='form-filed col-12 col-md-6'>
                    <span className={(billAddress && (!edited || edited && from !== "popup")) ? `input-title-view` : `input-title`}>City </span>
                    {billAddress ? edited && from === "popup" ? (<div >
                        <input
                            name="city"
                            type="text"
                            className={`input-value-filed ${validationType.touched.city &&
                                validationType.errors.city && `error-border`}`}
                            onChange={(e) => {
                                e.target.value = e.target.value;
                                validationType.handleChange(e);
                            }}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.city?.trimStart() || ""}
                            invalid={
                                validationType.touched.city &&
                                    validationType.errors.city
                                    ? true
                                    : false
                            }
                        />
                        {validationType.touched.city &&
                            validationType.errors.city ? (
                            <div className='error-msg'>
                                {validationType.errors.city}
                            </div>
                        ) : null}
                    </div>) : <div className='input-value-filed-value'>{billAddress.city ? billAddress.city : "-"}</div> : <div >
                        <input
                            name="city"
                            type="text"
                            className={`input-value-filed ${validationType.touched.city &&
                                validationType.errors.city && `error-border`}`}
                            onChange={(e) => {
                                e.target.value = e.target.value;
                                validationType.handleChange(e);
                            }}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.city?.trimStart() || ""}
                            invalid={
                                validationType.touched.city &&
                                    validationType.errors.city
                                    ? true
                                    : false
                            }
                        />
                        {validationType.touched.city &&
                            validationType.errors.city ? (
                            <div className='error-msg'>
                                {validationType.errors.city}
                            </div>
                        ) : null}
                    </div>}
                </div>
                <div className='form-filed col-12 col-md-6'>
                    <span className={(billAddress && (!edited || edited && from !== "popup")) ? `input-title-view` : `input-title`}>Country <span className="text-danger"> *</span></span>
                    {billAddress ? edited && from === "popup" ? (<div>
                        <select
                            name="country_name"
                            id=""
                            className={`input-value-filed ${validationType.touched.country_name &&
                                validationType.errors.country_name && `error-border`}`}
                            onChange={(e) => {
                                e.target.value = e.target.value;
                                validationType.handleChange(e);
                                validationType.setFieldValue("state", "")


                            }}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.country_name?.trimStart() || ""}
                        >
                            {validationType.values.country_name === "" && <option value="">Select a country</option>}

                            {countryList?.map(country => (
                                <option
                                    value={country.CountryName}
                                    key={country.CountryName}
                                >
                                    {`${country.CountryName}`}
                                </option>
                            ))}
                        </select>
                        {validationType.touched.country_name &&
                            validationType.errors.country_name ? (
                            <div className='error-msg'>
                                {validationType.errors.country_name}
                            </div>
                        ) : null}
                    </div>) : <div className='input-value-filed-value'>{billAddress.country_name}</div> : <div>
                        <select
                            name="country_name"
                            id=""
                            className={`input-value-filed ${validationType.touched.country_name &&
                                validationType.errors.country_name && `error-border`}`}
                            onChange={(e) => {
                                e.target.value = e.target.value;
                                validationType.handleChange(e);
                                validationType.setFieldValue("state", "")
                            }}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.country_name || ""}
                        >
                            {validationType.values.country_name === "" && <option value="">Select a country</option>}

                            {countryList?.map(country => (
                                <option
                                    value={country.CountryName}
                                    key={country.CountryName}
                                >
                                    {`${country.CountryName}`}
                                </option>
                            ))}
                        </select>
                        {validationType.touched.country_name &&
                            validationType.errors.country_name ? (
                            <div className='error-msg'>
                                {validationType.errors.country_name}
                            </div>
                        ) : null}
                    </div>}
                </div>

            </div>

            <div className='row mt-3'>
                <div className='form-filed col-12 col-md-6 mt-3 mt-md-0'>
                    <span className={(billAddress && (!edited || edited && from !== "popup")) ? `input-title-view` : `input-title`}>State {(validationType.values?.country_name && statesList?.length) > 0 && <span className="text-danger"> *</span>}</span>
                    {billAddress ? edited && from === "popup" ? (<div >

                        <select
                            name="state"
                            id=""
                            className={`input-value-filed ${validationType.touched.state &&
                                validationType.errors.state && `error-border`} ${!validationType.values.country_name ? "disabled" : ""}`}
                            onChange={(e) => {
                                e.target.value = e.target.value;
                                validationType.handleChange(e);
                            }}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.state?.trimStart() || ""}
                            disabled={!validationType.values.country_name}
                        >
                            {validationType.values.state === "" && <option value="">Select a state</option>}

                            {statesList?.map(state => (

                                <option
                                    value={state.StateName}
                                    key={state.StateName}
                                >
                                    {`${state.StateName}`}
                                </option>
                            ))}
                        </select>

                        {validationType.touched.state &&
                            validationType.errors.state ? (
                            <div className='error-msg'>
                                {validationType.errors.state}
                            </div>
                        ) : null}

                    </div>) : <div className='input-value-filed-value'>{billAddress.state}</div> : <div >

                        <select
                            name="state"
                            id=""
                            className={`input-value-filed ${validationType.touched.state &&
                                validationType.errors.state && `error-border`} ${!validationType.values.country_name ? "disabled" : ""}`}
                            onChange={(e) => {
                                e.target.value = e.target.value;
                                validationType.handleChange(e);
                            }}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.state?.trimStart() || ""}
                            disabled={!validationType.values.country_name}
                        >
                            {validationType.values.state === "" && <option value="">Select a state</option>}

                            {statesList?.map(state => (

                                <option
                                    value={state.StateName}
                                    key={state.StateName}
                                >
                                    {`${state.StateName}`}
                                </option>
                            ))}
                        </select>
                        {validationType.touched.state &&
                            validationType.errors.state ? (
                            <div className='error-msg'>
                                {validationType.errors.state}
                            </div>
                        ) : null}
                    </div>}
                </div>
                <div className='form-filed col-12 col-md-6 mt-3 mt-md-0'>
                    <span className={(billAddress && (!edited || edited && from !== "popup")) ? `input-title-view` : `input-title`}>Zip code <span className="text-danger"> *</span> </span>
                    {billAddress ? edited && from === "popup" ? (<div >
                        <input
                            name="zip_code"
                            type="text"
                            className={`input-value-filed ${validationType.touched.zip_code &&
                                validationType.errors.zip_code && `error-border`}`}
                            onChange={(e) => {
                                e.target.value = e.target.value;
                                validationType.handleChange(e);
                            }}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.zip_code || ""}
                            invalid={
                                validationType.touched.zip_code &&
                                    validationType.errors.zip_code
                                    ? true
                                    : false
                            }
                        />
                        {validationType.touched.zip_code &&
                            validationType.errors.zip_code ? (
                            <div className='error-msg'>
                                {validationType.errors.zip_code}
                            </div>
                        ) : null}
                    </div>) : <div className='input-value-filed-value'>{billAddress.zip_code}</div> : <div >
                        <input
                            name="zip_code"
                            type="text"
                            className={`input-value-filed ${validationType.touched.zip_code &&
                                validationType.errors.zip_code && `error-border`}`}
                            onChange={(e) => {
                                e.target.value = e.target.value;
                                validationType.handleChange(e);
                            }}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.zip_code?.trimStart() || ""}
                            invalid={
                                validationType.touched.zip_code &&
                                    validationType.errors.zip_code
                                    ? true
                                    : false
                            }
                        />
                        {validationType.touched.zip_code &&
                            validationType.errors.zip_code ? (
                            <div className='error-msg'>
                                {validationType.errors.zip_code}
                            </div>
                        ) : null}
                    </div>}
                </div>
            </div>


        </div>
    )
}

export default BillingAdressFields